import type { CSSProperties, ReactNode } from "react";
import { tokens, enterDelay } from "../tokens";

interface RevealProps {
	children: ReactNode;
	// Position in the entrance sequence. Delay is derived and capped so late items do not queue.
	index?: number;
	as?: "div" | "section" | "li";
	style?: CSSProperties;
}

// Content enters, it does not appear: a fade and a short rise, staggered from the top. The rise is a
// transform, so the element holds its final laid out position from the first frame and nothing below
// it shifts. The controls a viewer came to act on take a low index so they arrive early.
export function Reveal({ children, index = 0, as = "div", style }: RevealProps) {
	const Tag = as;
	return (
		<Tag
			className="mm-enter"
			style={{
				animation: `mm-enter ${tokens.motion.entrance}ms ${tokens.motion.easing} both`,
				animationDelay: enterDelay(index),
				...style,
			}}
		>
			{children}
		</Tag>
	);
}
